import React, { useEffect, useState } from "react";
import { Header, HireMe, Logo, LogoImg, NavBar } from "../styles/home";
import { Link, useLocation } from "react-router-dom";
import Drawer from "../components/drawer";
import NavButton from "../components/nav-button";
import IlyosjonLogo from "../assets/my-logo.png";

const HeaderComponent = () => {
  const [color, setColor] = useState("");
  const location = useLocation();

  useEffect(() => {
    switch (location.pathname) {
      case "/contact":
        setColor("contact");
        break;
      case "/about":
        setColor("about");
        break;
      case "/":
        setColor("home");
        break;
      // case '/services':
      //   setColor('services');
      //   break;
      case "/project":
        setColor("project");
        break;
      default:
        setColor("");
    }
  }, [location.pathname]);

  return (
    <Header>
      <Link
        to={"/"}
        style={{
          textDecoration: "none",
          height: "100px",
          width: "170px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <NavButton
          label="<>ILYOSJON<>"
          color={color}
          disabled={color === "home"}
        />
      </Link>
      <NavBar>
        <Link to="">
          <NavButton label="Home" color={color} disabled={color === "home"} />
        </Link>
        <Link to="/about">
          <NavButton label="About" color={color} disabled={color === "about"} />
        </Link>
        <Link to="/project">
          <NavButton
            label="Project"
            color={color}
            disabled={color === "project"}
          />
        </Link>
        <Link to="/contact">
          <NavButton
            label="Contact"
            color={color}
            disabled={color === "contact"}
          />
        </Link>
      </NavBar>
      <Link to="/contact" style={{ textDecoration: "none" }}>
        <HireMe>Book a call</HireMe>
      </Link>
      <Drawer />
    </Header>
  );
};

export default HeaderComponent;
